module.exports = __webpack_public_path__ + "static/media/club-caprabo-bloque.98b6f4d7.png";